import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { Modal, Row } from 'react-bootstrap';

interface Props {
  onHide: () => void;
  show: boolean;
  style?: any;
  onConfirmClick?: () => void;
  message?: string;
  outlined?: boolean;
  imgSrc?: any;
}

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  message: {
    fontWeight: 600,
    padding: '20px',
    textAlign: 'center',
    margin: 0,
  },
  image: {
    width: '100%',
    marginBottom: '20px',
    display: 'block',
    alignSelf: 'center',
  },
  row: {
    justifyContent: 'center',
    height: '100%',
    padding: '20px',
    gap: '30px',
  },
  primaryButton: {
    width: 'auto',
    color: 'white',
    fontWeight: 600,
    borderRadius: '50px',
    backgroundColor: '#ff3c00',

    '&.outline': {
      backgroundColor: 'transparent',
      border: '2px solid #ff3c00',
      color: '#ff3c00',

      '&:hover': {
        backgroundColor: 'white',
      },
    },

    '&:hover': {
      backgroundColor: '#ff3c00',
      opacity: '0.9',
    },
  },
}));

const Modals: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const { onHide, onConfirmClick, outlined, imgSrc } = props;

  return (
    <Modal {...props} className={classes.modal} centered>
      <p className={classes.message}>{props.message ? props.message : ''}</p>
      {imgSrc && <img src={imgSrc} alt="Imagem" className={classes.image} />}
      <Row noGutters className={classes.row}>
        <Button
          className={`${classes.primaryButton} ${outlined ? 'outline' : ''}`}
          onClick={onHide}
        >
          {onConfirmClick ? 'Não' : 'Ok'}
        </Button>
        {onConfirmClick && (
          <Button
            className={classes.primaryButton}
            onClick={() => {
              onConfirmClick();
              onHide();
            }}
          >
            Sim
          </Button>
        )}
      </Row>
    </Modal>
  );
};

export default Modals;
